import styled, { css } from 'styled-components';
import { WhenInterface } from './WhenTypes';

export const When = styled.div.attrs(({ isShow }: WhenInterface) => ({
  'aria-hidden': !isShow,
}))<WhenInterface>`
  width: 100%;

  ${({ isShow }) =>
    !isShow &&
    css`
      width: 0;
      display: none;
    `}

  ${({ fullHeight }) =>
    fullHeight &&
    css`
      height: 100%;
    `}
`;
